import { applyFilters, doRequest } from "./helpers";

export default class EmailAddressService {
  static async getEmailAddressesForFilters(filters = null) {
    let path = "/email_address/for_filters";
    path = applyFilters(filters, path);
    const result = await doRequest("GET", path);
    return result;
  }
}
